export const IM_PRICING_GDE_UI_SUBSCRIPTIONDEALS_ENABLED =
  'im-pricing-gde-ui-subscriptiondeals-enabled';
export const IM_PRICING_GDE_UI_SAGECHAT_ENABLED =
  'im-pricing-gde-ui-sagechat-enabled';
export const IM_PRICING_GDE_UI_HYBRID_ENABLED =
  'im-pricing-gde-ui-hybriddeals-enabled';
export const IM_PRICING_GDE_UI_BEM_ENABLED =
  'im-pricing-gde-ui-bidentrymanagement-enabled';
export const IM_PRICING_GDE_UI_SECURITYGROUP_ENABLED =
  'im-pricing-gde-ui-securitygroup-enabled';
export const IM_PRICING_GDE_UI_BIDCOSTAVGCOST_ENABLED =
  'im-pricing-gde-ui-bidcostavgcost-enabled';
export const IM_PRICING_GDE_UI_GRACEPERIOD_ENABLED =
  'im-pricing-gde-ui-graceperiod-enabled';
export const IM_PRICING_GDE_UI_INTERNAL_FUNDING_ENABLED =
  'im-pricing-gde-ui-internalfunding-enabled';
export const IM_PRICING_GDE_UI_BIDATTRIBUTES_ENABLED =
  'im-pricing-gde-ui-bidattributes-enabled';
export const IM_PRICING_GDE_UI_MSRP_ENABLED = 'im-pricing-gde-ui-msrp-enabled';
export const IM_PRICING_GDE_UI_CLAIMIT_DISABLED =
  'im-pricing-gde-ui-claimit-disabled';
export const IM_PRICING_GDE_UI_BIDCOMBINABILITY_ENABLED =
  'im-pricing-gde-ui-bidcombinability-enabled';
export const IM_PRICING_GDE_UI_ORDERCOSTOVERRIDE_ENABLED =
  'im-pricing-gde-ui-ordercostoverride-enabled';
export const IM_PRICING_GDE_UI_RESELLERMANAGEMENT_ENABLED =
  'im-pricing-gde-ui-resellermanagement-enabled';
export const FEATURE_FLAGS = [
  IM_PRICING_GDE_UI_SUBSCRIPTIONDEALS_ENABLED,
  IM_PRICING_GDE_UI_SAGECHAT_ENABLED,
  IM_PRICING_GDE_UI_HYBRID_ENABLED,
  IM_PRICING_GDE_UI_BEM_ENABLED,
  IM_PRICING_GDE_UI_SECURITYGROUP_ENABLED,
  IM_PRICING_GDE_UI_BIDCOSTAVGCOST_ENABLED,
  IM_PRICING_GDE_UI_GRACEPERIOD_ENABLED,
  IM_PRICING_GDE_UI_INTERNAL_FUNDING_ENABLED,
  IM_PRICING_GDE_UI_BIDATTRIBUTES_ENABLED,
  IM_PRICING_GDE_UI_MSRP_ENABLED,
  IM_PRICING_GDE_UI_CLAIMIT_DISABLED,
  IM_PRICING_GDE_UI_BIDCOMBINABILITY_ENABLED,
  IM_PRICING_GDE_UI_ORDERCOSTOVERRIDE_ENABLED,
  IM_PRICING_GDE_UI_RESELLERMANAGEMENT_ENABLED,
];
